<template>
  <div v-if="dialogVisible" class="csgo-mask login">
    <div class="reg-warp">
      <div class="btn-x" @click="onClose">
        <img src="@/assets/images/btn-x.png" alt="" srcset="">
      </div>
      <div class="login-title">{{ title }}</div>
      <div class="tip" v-if="tip">{{ tip }}</div>
      <div class="input">
        <el-input v-if="formType != 'password' && formType != 'idCard'" class="input1" v-model="formContent" :placeholder="placeholder"></el-input>
        <template v-if="formType == 'password'">
          <div class="input1-warp">
            <el-input class="input1" v-model="pasword.password_old" placeholder="请输入原密码" :type="pasword.isLookO?'text':'password'"></el-input>
            <div class="getCode" @click="pasword.isLookO=!pasword.isLookO">
              <i class="iconfont" :class="[pasword.isLookO?'icon-zhengyan':'icon-biyan']"></i>
            </div>
          </div>
          <div class="input1-warp">
            <el-input class="input1" v-model="pasword.password_new" placeholder="请输入新密码" :type="pasword.isLook?'text':'password'"></el-input>
            <div class="getCode" @click="pasword.isLook=!pasword.isLook">
              <i class="iconfont" :class="[pasword.isLook?'icon-zhengyan':'icon-biyan']"></i>
            </div>
          </div>
          <div class="input1-warp">
            <el-input class="input1" v-model="pasword.again_password" placeholder="再次输入新密码" :type="pasword.isLookA?'text':'password'"></el-input>
            <div class="getCode" @click="pasword.isLookA=!pasword.isLookA">
              <i class="iconfont" :class="[pasword.isLookA?'icon-zhengyan':'icon-biyan']"></i>
            </div>
          </div>
        </template>

        <el-input v-if="formType == 'idCard'" class="input1" v-model="formContent" placeholder="请输入姓名"></el-input>
        <el-input v-if="formType == 'idCard'" class="input1" v-model="formContent2" placeholder="请输入身份证号"></el-input>
      </div>
      <div v-if="formType == 'tradeUrl'" class="flex flex-ac flex-jsb">
        <div></div>
        <!-- <span class="go-login" @click="goUrl('https://www.bilibili.com/video/BV15D4y1X79w/')">点击看教程</span> -->
        <span class="go-login" @click="goUrl('https://steamcommunity.com/profiles/76561198891271608/tradeoffers/privacy#trade_offer_access_url')">获取你的Steam交易链接</span>
      </div>
      <div v-if="formType == 'idCard'" class="flex flex-ac flex-jsb" style="padding-top: 10px">
        根据相关规定，平台用户需要进行实名验证。实名信息仅用作认证使用，平台不会保存用户任何实名信息。
      </div>
      <div class="btn-w-r-bg" @click="onSubmit">
        <div class="btn-c-r">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import deepClone from "@/assets/js/deepClone.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      form: {
        name: '',
        nickname: '',
        username: '',
        gender: '',
        region_id: '',
        tradeUrl: ''
      },
      pasword: {
        password_old: '',
        password_new: '',
        again_password: '',
        isLookO: false,
        isLook: false,
        isLookA: false
      },
      title: '标题',
      placeholder: '请输入',
      placeholder2: '请输入',
      formType: '',
      tip: '',
      dialogVisible: false,
      formContent: '',
      formContent2: ''
    };
  },
  created() {
  },
  mounted() { },
  methods: {
    toggle(key) {
      this.formType = key
      this.title = ''
      this.tip = ''
      this.formContent = ''
      this.formContent2 = ''
      this.placeholder = '请输入'
      this.placeholder2 = '请输入'
      this.handleEdit(key)
      this.dialogVisible = true
    },
    onClose() {
      this.dialogVisible = false
      this.$store.commit('setPersonalOpen', '')
    },
    //steam教程
    goUrl(url) {
      window.open(url, "_blank");
    },
    //更换title tip  placeholder
    handleEdit(str) {
      this.formType = str
      if (str == 'name') {
        this.title = '昵称修改'
        this.tip = '昵称是一个可以让你在“PlaySkins”网站展示自己的个性化设置'
        this.placeholder = '请输入新的昵称'
      }
      if (str == 'bind') {
        this.title = '邀请码'
        this.tip = '邀请码可以让你在“PlaySkins”网站绑定邀请另一个玩家的设置'
        this.placeholder = '请输入邀请码'
      }
      // bind
      if (str == 'password') {
        this.title = '密码修改'
      }
      if (str == 'tradeUrl') {
        this.title = '交易地址'
        this.tip = '交易地址是一个可以让你与非好友玩家进行交易的地址'
        this.placeholder = '请输入你的STEAM交易地址'
      }
      // 实名认证
      if (str == 'idCard') {
        this.title = '实名认证'
        this.tip = '请输入与该手机号实名信息一致的姓名、身份证号进行实名认证'
        this.placeholder = '请输入姓名'
        this.placeholder2 = '请输入身份证'
      }
      this.formContent = deepClone(this.$store.state.userInfo[str])
    },
    onSubmit() {
      // 更换密码
      if (this.formType == 'password') {
        this.handelChangePwd()
        return false
      }
      // 实名认证
      if (this.formType == 'idCard') {
        this.handelIdCard()
        return false
      }
      if (!this.formContent) {
        this.$message.warning('请先输入' + this.placeholder)
        return false
      }
      if (this.formType == 'bind') {
        this.handelChangeBind()
        return false
      }
      let form = deepClone(this.$store.state.userInfo)
      form[this.formType] = this.formContent
      this.$doPost("/api/member.Member/edit", form).then((res) => {
        if (this.formType == 'name') {
          this.$store.state.name = form.name
        }
        this.$store.state.userInfo = form
        localStorage.setItem('userInfo', JSON.stringify(form))
        this.$message({
          message: "修改成功",
          type: "success",
        })
        this.dialogVisible = false
      }).catch(() => { })
    },
    handelChangeBind() {
      let form = deepClone(this.$store.state.userInfo)
      form.superior_code = this.formContent
      this.$doPost("/api/hall.Invite/bind", {
        invite_code: this.formContent
      }).then((res) => {
        this.$store.state.userInfo = form
        localStorage.setItem('userInfo', JSON.stringify(form))
        this.$message({
          message: "成功绑定上级",
          type: "success"
        })
        this.dialogVisible = false
      }).catch(() => { })
    },
    handelIdCard() {
      let form = deepClone(this.$store.state.userInfo)
      form.sure_name = 1000
      form.id_card = 1000
      this.$doPost("/api/member.Member/idCardCheck", {
        sure_name: this.formContent,
        id_card: this.formContent2
      }).then((res) => {
        this.$store.state.userInfo = form
        localStorage.setItem('userInfo', JSON.stringify(form))
        this.$message({
          message: "实名认证成功",
          type: "success"
        })
        this.dialogVisible = false
        if (this.$route.path == '/index/task-center') {
          window.location.reload()
        }
      }).catch(() => { })

    },
    handelChangePwd() {
      if (this.pasword.password_old == '') {
        this.$message.warning('请先输入原始密码!')
        return false
      }
      if (this.pasword.password_new == '') {
        this.$message.warning('请先输入新密码!')
        return false
      }
      if (this.pasword.again_password == '') {
        this.$message.warning('请再次输入新密码!')
        return false
      }
      if (this.pasword.again_password != this.pasword.password_new) {
        this.$message.warning('您两次输入的密码不一致!')
        return false
      }
      this.$doPost("/api/member.Member/pwd", this.pasword).then((res) => {
        this.pasword = {
          password_old: '',
          password_new: '',
          again_password: '',
          isLookO: false,
          isLook: false,
          isLookA: false
        }
        this.$message({
          message: "修改成功",
          type: "success"
        })
        this.dialogVisible = false
      }).catch(() => { })

    }
  },
};
</script>

<style lang="less" scoped>
// 这个是弹窗的样式
.reg-warp {
  height: 468px;
  width: 500px;
  max-width: 500px;
  padding: 38px 35px;
  .login-title {
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    padding: 22px 0 0;
  }
  .tip {
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    margin-top: 10px;
  }
}
</style>
